import * as m from "./../../../dist/es2015/plugins/sliceGrouper.js";
export const am5plugins_sliceGrouper = m;